'use strict';

var d3 = require('d3');

var toolTipHandler = { offsets: { x: 0, y: 0 } };

toolTipHandler.addMinimalContent = function (htmlContent, toolTip, environment) {

	if (environment === 'standAlone' || environment === 'logi') {
		var container = document.getElementById('container-paralellplot');
		toolTipHandler.offsets.x = container.offsetLeft;
		toolTipHandler.offsets.y = container.offsetTop;
	}

	toolTip.minimal.htmlContent.html(htmlContent);
	toolTip.style('display', 'inline-block');
	toolTip.active = true;
};

toolTipHandler.addExtendedContent = function (htmlContent, toolTip) {
	toolTip.active = true;
};

toolTipHandler.position = function (toolTip, event, environment) {

	var e = d3.select('.tooltip');
	var tt = document.getElementById('tooltip');
	var eMinimal = e.select('.minimal').node();
	var wMinimal = eMinimal.getBoundingClientRect().width;
	var hMinimal = eMinimal.getBoundingClientRect().height;

	var posToolTip = {
		top: { className: 'top', top: event.pageY - hMinimal - 12 - toolTipHandler.offsets.y, left: event.pageX - wMinimal / 2 - 6 - toolTipHandler.offsets.x, pointer: { left: 50, top: 100 } },
		left: { className: 'left', top: event.pageY - hMinimal / 2 - 5, left: event.pageX - wMinimal - 10 - 6, pointer: { left: 100, top: 50 } },
		right: { className: 'right', top: event.pageY - hMinimal / 2 - 5, left: event.pageX + 10 + 6, pointer: { left: 0, top: 50 } }
	};

	var checkTop = event.pageY - (hMinimal + 12);
	var checkRight = event.pageX + wMinimal / 2;
	var checkLeft = 0;

	var pos = posToolTip.top;
	if (checkTop <= 0) {
		pos = posToolTip.left;
	} else if (checkRight >= window.innerWidth) {
		pos = posToolTip.top;
	} else if (checkRight <= 0) {
		pos = posToolTip.right;
	}

	if (pos.top <= 4) {
		pos.top = 4;
		pos.pointer.top = event.pageY / hMinimal * 100 - 4;
	}

	if (pos.left >= window.innerWidth - 4 - wMinimal) {
		pos.left = window.innerWidth - 4 - wMinimal;
		pos.pointer.left = (event.pageX - tt.offsetLeft) / wMinimal * 100;
	}

	toolTip.minimal.pointer.attr('class', pos.className);

	toolTip.style("top", +pos.top + "px").style("left", +pos.left + "px");

	toolTip.minimal.select('.' + pos.className).style('left', pos.pointer.left + '%').style('top', pos.pointer.top + '%');
};

toolTipHandler.remove = function (toolTip) {

	toolTip.active = false;
	toolTip.style('display', 'none');
};

module.exports = toolTipHandler;